import { render, staticRenderFns } from "./logout-alert.vue?vue&type=template&id=059da55c&scoped=true&"
import script from "./logout-alert.vue?vue&type=script&lang=js&"
export * from "./logout-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059da55c",
  null
  
)

export default component.exports